module.exports = __webpack_public_path__ + "img/56_74.eeb96e85.png";